import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EditalParametro } from '../../models/edital-parametro';
import { InscricaoParametro } from '../../models/inscricao-parametro';
import { Convocacao } from '../../models/convocacao.model';
import { convocacaoDeficiente } from '../../models/convocacao-deficiente.model';
import { EditalTipo } from '../../models/edital-tipo';
import { RouteDataService } from './route-data.service';
import { Inscricao } from '../../models/inscricao-model';
import { InscricaoFilter } from '../../models/inscricao-filter';

const RouteTransfers = {
    loginToCandidato: 'login -> candidato',
    loginToCandidatoPainel: 'login -> candidato / painel',
    loginToInscricao: 'login -> inscricao',
    painelToCandidatoUpdate: 'painel -> candidato->update',
    anyToEdital: 'qualquerLugar -> edital',
    painelToCandidatoAcompanhamento: 'painel -> candidato / acompanhamento',
    painelToCandidatoConvocado: 'painel -> candidato-convocado',
    editalToEditalDetalhe: 'edital -> edital-detalhe',
    editalToLogin: 'edital -> login',
    editalToInscricao: 'edital -> inscricao',
    editalToInscricaoPreencher: 'edital -> inscricao',
    anyToHome: 'qualquerLugar -> home',
    anyToLogin: 'qualquerLugar -> login',
    recuperarSenhaToLogin: 'recuperar-senha -> login',
    inscricaoToCandidatoPainel: 'inscricao -> candidato / painel',
    inscricaoToCandidatoAcompanhamento: 'inscricao -> candidato / acompanhamento',
    inscricaoToCandidatoConvocado: 'inscricao -> candidato-convocado',
    candidatoConvocadoToDesistir: 'candidato-convocado / desistir',
    dadosCandidatoConvocado: 'candidato-convocado / dados-adicionais',
    inscricaoToInscricaoDetalhe: 'inscricao -> inscricao-detalhe',
    inscricaoToEnviarArquivo: 'inscricao -> candidato-enviar-arquivo',
    candidatoTCandidatoPainel: 'candidato -> candidato / painel',
    convocacaoToConvocacaoDetalhe: 'convocacao -> convocacao-detalhe',
    convocacaoDefToConvocacaoDetalhe: 'avaliacao-deficiente -> avaliacao-deficiente-detalhe',
    painelServidorToConvocacaoDeficiente: 'painel-servidor -> avaliacao-deficiente',
};

@Injectable()
export class RouteNavigationService {
    constructor(
        private router: Router,
        private routeDataService: RouteDataService,
    ) { }

    fromAnyToLogin() {
        this.router.navigate(['login/']);
    }

    fromAnyAlterarSenha() {
        this.router.navigate(['alterar-senha/']);
    }

    fromAnyToConvocacao() {
        this.router.navigate(['convocacao/']);
    }

    fromAnyToAvaliacao() {
        this.router.navigate(['avaliacao/']);
    }

    fromAnyToAvaliacaoDeficiente() {
        this.router.navigate(['avaliacao-deficiente/']);
    }

    fromAnyToPublicarArquivo() {
        this.router.navigate(['publicar-arquivo/']);
    }

    fromAnyToModalProcessar() {
        this.router.navigate(['processar-classificacao/']);
    }

    fromConvocacaoToConvocacaoDetalhe() {
        this.router.navigate(['convocacao/convocar']);
    }

    fromAvaliacaoDeficienteToAvaliavaoDeficienteDetalhe() {
        this.router.navigate(['avaliacao-deficiente/avaliar']);
    }

    fromConvocacaoToConvocacaoDetalheView(convocacao: Convocacao) {
        this.routeDataService.transfer(RouteTransfers.convocacaoToConvocacaoDetalhe, { convocacao: convocacao });
        this.router.navigate(['convocacao/view']);
    }

    fromConvocacaoToConvocacaoDetalheUpdate(convocacao: Convocacao) {
        this.routeDataService.transfer(RouteTransfers.convocacaoToConvocacaoDetalhe, { convocacao: convocacao });
        this.router.navigate(['convocacao/update']);
    }

    getDataConvocacaoToConvocacaoDetalhe(): Convocacao {
        const data = this.routeDataService.retrieve(RouteTransfers.convocacaoToConvocacaoDetalhe);
        if (!data) {
            return null;
        }
        return data;
    }

    fromConvocacaoDefToConvocacaoDetalheUpdate(convocacao: convocacaoDeficiente) {
        this.routeDataService.transfer(RouteTransfers.convocacaoDefToConvocacaoDetalhe, { convocacao: convocacao });
        this.router.navigate(['avaliacao-deficiente/update']);
    }

    fromConvocacaoDefToConvocacaoDetalheView(convocacao: convocacaoDeficiente) {
        this.routeDataService.transfer(RouteTransfers.convocacaoDefToConvocacaoDetalhe, { convocacao: convocacao });
        this.router.navigate(['avaliacao-deficiente/view']);
    }

    getDataConvocacaoDefToConvocacaoDetalhe(): convocacaoDeficiente {
        const data = this.routeDataService.retrieve(RouteTransfers.convocacaoDefToConvocacaoDetalhe);
        if (!data) {
            return null;
        }
        return data;
    }

    fromLoginToCandidato(cpf: string) {
        this.routeDataService.transfer(RouteTransfers.loginToCandidato, { cpf: cpf });
        this.router.navigate(['login-internet/candidato/']);
    }

    getDataLoginToCandidato(): number {
        const data = this.routeDataService.retrieve(RouteTransfers.loginToCandidato);
        if (!data) {
            return null;
        }
        return data.cpf;
    }

    fromLoginToCandidatoPainel() {
        this.router.navigate(['candidato/painel/']);
    }
    fromLoginToServidorPainel() {
        this.router.navigate(['servidor/painel/']);
    }

    getDataLoginToCandidatoPainel(): string {
        const data = this.routeDataService.retrieve(RouteTransfers.loginToCandidatoPainel);
        if (!data) {
            return null;
        }
        return data.cpf;
    }

    fromCandidatoTCandidatoPainel(cpf: number) {
        this.routeDataService.transfer(RouteTransfers.candidatoTCandidatoPainel, { cpf: cpf });
        this.router.navigate(['candidato/painel/']);
    }

    getDataCandidatoTCandidatoPainel(): number {
        const data = this.routeDataService.retrieve(RouteTransfers.candidatoTCandidatoPainel);
        if (!data) {
            return null;
        }
        return data.cpf;
    }

    fromInscricaoToCandidatoPainel(cpf: string) {
        this.routeDataService.transfer(RouteTransfers.inscricaoToCandidatoPainel, { cpf: cpf });
        this.router.navigate(['candidato/painel/']);
    }

    getDataInscricaoToCandidatoPainel(): string {
        const data = this.routeDataService.retrieve(RouteTransfers.inscricaoToCandidatoPainel);
        if (!data) {
            return null;
        }
        return data.cpf;
    }

    fromInscricaoToInscricaoDetalhe(inscricao: Inscricao) {
        this.routeDataService.transfer(RouteTransfers.inscricaoToInscricaoDetalhe, { inscricao: inscricao });
        this.router.navigate(['candidato/detalhe/']);
    }

    getDataInscricaoToInscricaoDetalhe(): Inscricao {
        const data = this.routeDataService.retrieve(RouteTransfers.inscricaoToInscricaoDetalhe);
        if (!data) {
            return null;
        }
        return data.inscricao;
    }

    fromLoginToIncricao(cpf: string, codPessoa: number, tipo: number, itemconc: number, cdhierarq: number) {
        this.routeDataService.transfer(RouteTransfers.loginToInscricao, { cpf: cpf, codPessoa: codPessoa, tipo: tipo, itemconc: itemconc, cdhierarq: cdhierarq });
        this.router.navigate(['edital/inscricao/']);
    }

    getDataLoginToIncricao(): InscricaoParametro {
        const data = this.routeDataService.retrieve(RouteTransfers.loginToInscricao);
        if (!data) {
            return null;
        }
        return data;
    }

    fromPainelToCandidatoUpdate() {
        this.router.navigate(['candidato/update/']);
    }

    getDataPainelToCandidatoUpdate(): string {
        const data = this.routeDataService.retrieve(RouteTransfers.painelToCandidatoUpdate);
        if (!data) {
            return null;
        }
        return data.cpf;
    }

    fromAnyToCandidatoEnviarArquivo(inscricao: Inscricao) {
        this.routeDataService.transfer(RouteTransfers.inscricaoToEnviarArquivo, { inscricao: inscricao });
        this.router.navigate(['candidato-enviar-arquivo']);
    }

    getDataCandidatoEnviarArquivo(): Inscricao {
        const data = this.routeDataService.retrieve(RouteTransfers.inscricaoToEnviarArquivo);
        if (!data) {
            return null;
        }
        return data.inscricao;
    }

    toCandidatoConvocado() {
        this.router.navigate(['candidato-convocado']);
    }

    fromAnyToCandidatoConvocado(inscricao: Inscricao) {
        this.routeDataService.transfer(RouteTransfers.inscricaoToCandidatoConvocado, { inscricao: inscricao });
        this.toCandidatoConvocado();
    }

    getDataCandidatoConvocado(): Inscricao {
        const data = this.routeDataService.retrieve(RouteTransfers.inscricaoToCandidatoConvocado);
        if (!data) {
            return null;
        }
        return data.inscricao;
    }


    toDesistirConvocacao() {
        this.router.navigate(['/desistir-convocacao']);
    }

    fromAnyToDesistirConvocacao(inscricao: Inscricao) {
        this.routeDataService.transfer(RouteTransfers.candidatoConvocadoToDesistir, { inscricao: inscricao });
        this.toDesistirConvocacao();
    }

    getDataDesistirConvocacao(): Inscricao {
        const data = this.routeDataService.retrieve(RouteTransfers.candidatoConvocadoToDesistir);
        if (!data) {
            return null;
        }
        return data.inscricao;
    }
   

    fromAnyToDadosAdicionais(inscricao: Inscricao) {
        this.routeDataService.transfer(RouteTransfers.dadosCandidatoConvocado, { inscricao: inscricao });
        this.router.navigate(['/dados-adicionais']);
    }

    getDataDadosCandidatoConvocado(): Inscricao {
        const data = this.routeDataService.retrieve(RouteTransfers.dadosCandidatoConvocado);
        if (!data) {
            return null;
        }
        return data.inscricao;
    }

    fromAnyToDeclaracaoAcumuloCargo(inscricao: Inscricao) {
        this.routeDataService.transfer(RouteTransfers.dadosCandidatoConvocado, { inscricao: inscricao });
        this.router.navigate(['/declaracao-acumulo-cargo']);
    }  


    fromAnyToEdital(tipo: number, tpConc: number) {
        this.routeDataService.transfer(RouteTransfers.anyToEdital, { tipo: tipo, tpConc: tpConc });
        this.router.navigate(['edital/']);
    }

    getDataAnyToEdital(): EditalTipo {
        const data = this.routeDataService.retrieve(RouteTransfers.anyToEdital);
        if (!data) {
            return null;
        }
        return data;
    }

    fromPainelCandidatoToAcompanhamento() {
        this.fromPainelCandidatoToAcompanhamentoFiltroVoltar(null);
        this.router.navigate(['candidato/acompanhamento/']);
    }

    toAcompanhamentoInscricao() {
        this.router.navigate(['candidato/acompanhamento/']);
    }

    fromPainelCandidatoToAcompanhamentoFiltroVoltar(inscricaoFilter: InscricaoFilter) {
        this.routeDataService.transfer(RouteTransfers.inscricaoToCandidatoAcompanhamento, { inscricaoFilter: inscricaoFilter });
    }

    fromPainelCandidatoToPainelConvocacaoFiltroVoltar(inscricaoFilter: InscricaoFilter) {
        this.routeDataService.transfer(RouteTransfers.inscricaoToCandidatoConvocado, { inscricaoFilter: inscricaoFilter });
    }

    getPainelCandidatoToAcompanhamentoFiltroVoltar(): InscricaoFilter {
        var data = this.routeDataService.retrieve(RouteTransfers.inscricaoToCandidatoAcompanhamento);
        if (!data) {
            return null;
        };
        return data.inscricaoFilter;
    }

    getDataPainelToCandidatoAcompanhamento(): string {
        const data = this.routeDataService.retrieve(RouteTransfers.painelToCandidatoAcompanhamento);
        if (!data) {
            return null;
        };
        return data.cpf;
    }

    fromInscricaoToCandidatoAcompanhamento(cpf: string) {
        this.routeDataService.transfer(RouteTransfers.inscricaoToCandidatoAcompanhamento, { cpf: cpf });
        this.router.navigate(['candidato/acompanhamento/']);
    }

    getDataInscricaoToCandidatoAcompanhamento(): string {
        const data = this.routeDataService.retrieve(RouteTransfers.inscricaoToCandidatoAcompanhamento);
        if (!data) {
            return null;
        }
        return data.cpf;
    }

    fromEditalToEditalDetalhe(tipo: number, itemconc: number, cdhierarq: number, tpConc: number) {
        this.routeDataService.transfer(RouteTransfers.editalToEditalDetalhe, { tipo: tipo, itemconc: itemconc, cdhierarq: cdhierarq, tpConc: tpConc });
        this.router.navigate(['edital/consulta/']);
    }

    getDataEditalToEditalDetalhe(): EditalParametro {
        const data = this.routeDataService.retrieve(RouteTransfers.editalToEditalDetalhe);
        if (!data) {
            return null;
        };
        return data;
    }

    getDataEditalToEdital(): EditalParametro {
        const data = this.routeDataService.retrieve(RouteTransfers.editalToLogin);
        if (!data) {
            return null;
        };
        return data;
    }

    fromEditalToLogin(tipo: number, itemconc: number, cdhierarq: number) {
        this.routeDataService.transfer(RouteTransfers.editalToLogin, { tipo: tipo, itemconc: itemconc, cdhierarq: cdhierarq });
        this.router.navigate(['login/']);
    }


    fromEditalToIncricao(tipo: number, itemconc: number, cdhierarq: number) {
        this.routeDataService.transfer(RouteTransfers.editalToInscricao, { tipo: tipo, itemconc: itemconc, cdhierarq: cdhierarq });
        this.router.navigate(['edital/inscricao/']);
    }

    getDataEditalToIncricao(): InscricaoParametro {
        const data = this.routeDataService.retrieve(RouteTransfers.editalToInscricao);
        if (!data) {
            return null;
        }
        return data;
    }

    fromRecuperarSenhaToLogin(mensagem: string) {
        this.routeDataService.transfer(RouteTransfers.recuperarSenhaToLogin, { message: mensagem });
        this.router.navigate(['login/']);
    }

    getRecuperarSenhaToLogin(): string {
        const data = this.routeDataService.retrieve(RouteTransfers.recuperarSenhaToLogin);
        if (!data) {
            return null;
        }
        return data.message;
    }

    fromMinhasInscricorsTCandidatoPainel() {
        this.router.navigate(['candidato/painel/']);
    }

    fromAnyToHome() {
        this.router.navigate(['home/']);
    }
}


// WEBPACK FOOTER //
// ./src/app/services/api/route-navigation.service.ts